import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createClinicLabProfile = createAsyncThunk(
    "clinicLabProfile/createClinicLabProfile",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("clinicLabProfile/createClinicLabProfile", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const updateClinicLabProfile = createAsyncThunk(
    "clinicLabProfile/updateClinicLabProfile",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/clinicLabProfile/updateClinicLabProfile", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getAllClinicLabProfile = createAsyncThunk(
    "clinicLabProfile/getAllClinicLabProfile",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicLabProfile/getAllClinicLabProfile", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getClinicLabProfileByClinicId = createAsyncThunk(
    "clinicLabProfile/getClinicLabProfileByClinicId",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicLabProfile/getClinicLabProfileByClinicId", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getClinicLabProfileByProfileId = createAsyncThunk(
    "clinicLabProfile/getClinicLabProfileByProfileId",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicLabProfile/getClinicLabProfileByProfileId", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const deletedClinicLabProfile = createAsyncThunk(
    "clinicLabProfile/deleteClinicTestProfile",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/clinicLabProfile/deletedClinicLabProfile", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const deleteTestFromClinicLabProfile = createAsyncThunk(
    "clinicLabProfile/deleteTestFromClinicLabProfile",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/clinicLabProfile/deleteTestFromClinicLabProfile", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    loading: false,
    clinicTestProfile: [],
    clinicTestProfileByClinicId: [],
    clinicLestProfileDetails: [],
    searchMessage: null,
    createClinicTestProfileSuccessMessage: null,
    createClinicTestProfileErrorMessage: null,
    updateClinicTestProfileSuccessMessage: null,
    updateClinicTestProfileErrorMessage: null,
    deleteClinicTestProfileSuccessMessage: null,
    deleteClinicTestProfileErrorMessage: null,
    deleteTestinClinicLabProfileSuccessMessage: null,
    deleteTestinClinicLabProfileErrorMessage: null
}

const citySlice = createSlice({
    name: "clinicLabProfile",
    initialState,
    reducers: {
        resetCreateClinicTestProfileMessage: (state) => {
            state.createClinicTestProfileSuccessMessage = null;
            state.createClinicTestProfileErrorMessage = null;
        },
        resetUpdateClinicTestProfileMessage: (state) => {
            state.updateClinicTestProfileSuccessMessage = null;
            state.updateClinicTestProfileErrorMessage = null;
        },
        resetDeleteClinicTestProfileMessage: (state) => {
            state.deleteClinicTestProfileSuccessMessage = null;
            state.deleteClinicTestProfileErrorMessage = null;
        },
        resetDeleteTestinClinicLabProfileMessage: (state) => {
            state.deleteTestinClinicLabProfileSuccessMessage = null;
            state.deleteTestinClinicLabProfileErrorMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createClinicLabProfile.pending, (state) => {
                state.loading = true;
                state.createClinicTestProfileSuccessMessage = null;
                state.createClinicTestProfileErrorMessage = null;
            })
            .addCase(createClinicLabProfile.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.createClinicTestProfileErrorMessage = action.payload.result.message;
                } else {
                    state.createClinicTestProfileSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(createClinicLabProfile.rejected, (state, action) => {
                state.loading = false;
                state.createClinicTestProfileErrorMessage = action.payload.result.message;
            })
            .addCase(updateClinicLabProfile.pending, (state) => {
                state.loading = true;
                state.updateClinicTestProfileSuccessMessage = null;
                state.updateClinicTestProfileErrorMessage = null;
            })
            .addCase(updateClinicLabProfile.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.updateClinicTestProfileErrorMessage = action.payload.result.message;
                } else {
                    state.updateClinicTestProfileSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(updateClinicLabProfile.rejected, (state, action) => {
                state.loading = false;
                state.updateClinicTestProfileErrorMessage = action.payload.result.message;
            })
            .addCase(getAllClinicLabProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllClinicLabProfile.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchMessage = action.payload.result.message;
                    state.clinicTestProfile = [];
                } else {
                    state.searchMessage = null;
                    state.clinicTestProfile = action.payload.result.list;
                }
            })
            .addCase(getAllClinicLabProfile.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getClinicLabProfileByClinicId.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClinicLabProfileByClinicId.fulfilled, (state, action) => {
                state.loading = false;
                state.clinicTestProfileByClinicId = action.payload.result.list
            })
            .addCase(getClinicLabProfileByClinicId.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(deletedClinicLabProfile.pending, (state) => {
                state.loading = true;
                state.deleteClinicTestProfileSuccessMessage = null;
                state.deleteClinicTestProfileErrorMessage = null;
            })
            .addCase(deletedClinicLabProfile.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.deleteClinicTestProfileErrorMessage = action.payload.result.message;
                } else {
                    state.deleteClinicTestProfileSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(deletedClinicLabProfile.rejected, (state, action) => {
                state.loading = false;
                state.deleteClinicTestProfileErrorMessage = action.payload.result.message;
            })
            .addCase(deleteTestFromClinicLabProfile.pending, (state) => {
                state.loading = true;
                state.deleteTestinClinicLabProfileSuccessMessage = null;
                state.deleteTestinClinicLabProfileErrorMessage = null;
            })
            .addCase(deleteTestFromClinicLabProfile.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.deleteTestinClinicLabProfileErrorMessage = action.payload.result.message;
                } else {
                    state.deleteTestinClinicLabProfileSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(deleteTestFromClinicLabProfile.rejected, (state, action) => {
                state.loading = false;
                state.deleteTestinClinicLabProfileErrorMessage = action.payload.result.message;
            })
            .addCase(getClinicLabProfileByProfileId.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClinicLabProfileByProfileId.fulfilled, (state, action) => {
                state.loading = false;
                state.clinicLestProfileDetails = action.payload.result.list;
            })
            .addCase(getClinicLabProfileByProfileId.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const { resetCreateClinicTestProfileMessage, resetUpdateClinicTestProfileMessage, resetDeleteClinicTestProfileMessage, resetDeleteTestinClinicLabProfileMessage } = citySlice.actions;

export default citySlice.reducer;